import * as React from "react";
import type { SVGProps } from "react";

interface EndOfOvertimeProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const EndOfOvertime = ({ cancelled = false, ...props }: EndOfOvertimeProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(.2 .2)">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M9.55 0a9.55 9.55 0 1 1 0 19.1 9.55 9.55 0 0 1 0-19.1"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M9.55.75a8.8 8.8 0 1 1 0 17.6 8.8 8.8 0 0 1 0-17.6"
        />
        <circle cx={9.55} cy={9.55} r={7.5} fill="#FF1212" />
        <path
          fill="#FFF"
          stroke="#000"
          strokeWidth={1.1}
          d="M6.07 5.65h7.16c.23 0 .42.19.42.42v7.58H6.07a.42.42 0 0 1-.42-.42V6.07c0-.23.19-.42.42-.42Z"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M6.82 18.69c-.8.65-.93 1.84-.28 2.64l.59.73c.55.69 1.51.9 2.3.5l3.97-1.98.14.16a5.37 5.37 0 0 0 7.1.63l.17-.13a5.35 5.35 0 0 0 1.82-5.44l-.01-.06.05-.05c.57-.64.64-1.6.14-2.32l-.08-.12a1.88 1.88 0 0 0-2.15-.57l-.04.02v-.01a5.36 5.36 0 0 0-6.34.03l-.18.13a1.6 1.6 0 0 0-.5 1.76l.02.07-1.03.84a1.66 1.66 0 0 0-1.81.03l-.12.09z"
        />
        <path
          fill="#000"
          d="M7.2 19.15a1.28 1.28 0 0 0-.2 1.8l.6.73c.37.47 1.02.61 1.56.34l4.2-2.09a.28.28 0 0 1 .35.08l.02.03a4.76 4.76 0 0 0 8.23-4.44l-.03-.07.02-.02.13-.08c.54-.45.62-1.25.18-1.8a1.28 1.28 0 0 0-1.8-.2l.03-.01-.06-.05a4.77 4.77 0 0 0-5.85-.18l-.18.13a1 1 0 0 0-.15 1.4l.04.05c.02.03.02.06 0 .08l-1.76 1.42a.06.06 0 0 1-.08 0 1.06 1.06 0 0 0-1.49-.17zm.63.78 3.76-3.05a.06.06 0 0 1 .08.01c.37.45 1.04.52 1.5.16l1.74-1.42c.46-.37.53-1.03.16-1.49l-.04-.04.16-.12a3.77 3.77 0 0 1 4.84.37l.14.15a.5.5 0 0 0 .84-.17.26.26 0 0 1 .08-.12c.12-.1.3-.07.4.05s.07.3-.04.39a.26.26 0 0 1-.18.06.5.5 0 0 0-.46.72 3.76 3.76 0 0 1-1 4.57 3.77 3.77 0 0 1-5.3-.6h-.02a1.28 1.28 0 0 0-1.58-.36l-4.2 2.09a.28.28 0 0 1-.34-.08l-.59-.72a.28.28 0 0 1 .05-.4"
        />
        <path
          fill="#000"
          d="M15.95 15.2c-.99.82-1.14 2.3-.33 3.3a2.3 2.3 0 0 0 3.25.36c1-.82 1.15-2.3.34-3.3a2.3 2.3 0 0 0-3.26-.35Zm.64.78a1.3 1.3 0 0 1 1.84.2c.47.59.38 1.44-.19 1.9a1.3 1.3 0 0 1-1.84-.2 1.36 1.36 0 0 1 .19-1.9"
        />
      </g>
      <g fillRule="nonzero">
        <path
          fill="#FFF"
          d="M20.15 0c.77 0 1.4.63 1.4 1.4v1.1h1.1c.73 0 1.33.56 1.4 1.27v.13c0 .77-.63 1.4-1.4 1.4h-1.1v1.1a1.4 1.4 0 0 1-1.27 1.4h-.13a1.4 1.4 0 0 1-1.4-1.4V5.3h-1.1a1.4 1.4 0 0 1-1.4-1.27V3.9c0-.77.63-1.4 1.4-1.4h1.1V1.4c0-.73.56-1.33 1.27-1.4z"
        />
        <path
          fill="#000"
          d="M20.15.75c.36 0 .65.3.65.65v1.85h1.85a.65.65 0 1 1 0 1.3H20.8V6.4a.65.65 0 1 1-1.3 0V4.55h-1.85a.65.65 0 1 1 0-1.3h1.85V1.4c0-.36.3-.65.65-.65"
        />
      </g>
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default EndOfOvertime;
